import { render } from "./MappingList.vue?vue&type=template&id=a6935660&scoped=true"
import script from "./MappingList.vue?vue&type=script&lang=js"
export * from "./MappingList.vue?vue&type=script&lang=js"

import "./MappingList.vue?vue&type=style&index=0&id=a6935660&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a6935660"

export default script